export default __webpack_public_path__ + "static/media/ipad.9d00aee9.png";